import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { HROnboardingPage } from "@/components/hr/hr-onboarding-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/hr/onboarding",
  component: HROnboardingPageGuard,
});

function HROnboardingPageGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  if ((session?.user as { role?: string })?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <HROnboardingPage />;
}
